module.exports = __webpack_public_path__ + "static/media/chopin_airport_logo_PL.e6b48c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chopin_airport_logo_PL.png
// module id = 1098
// module chunks = 0